<template>
  <b-col :key="$store.getters['resource/currentResource'].key"
         class="white-container">
    <loader v-if="loading"/>
    <b-row>
      <b-col md="4">
        <b-input-group class="flex-column">
          <label :for="'name'">{{$t('form.name')}}<span class="text-danger">{{$t('form.required_star')}}</span></label>
          <b-form-input
            class="mb-4 rounded"
            v-model="name"
            name="name"
            id="name"
            @input="value => {createParamsObject('name', value)}"
          />
        </b-input-group>
        <span class="text-danger position-absolute error"
              v-if="!$v.name.required && $v.name.$dirty">
            {{$t('form.required_field')}}
        </span>
        <span class="text-danger position-absolute error"
              v-if="!$v.name.maxLength && $v.name.$dirty">
            {{$t('errors.error_must_have') + " " + $v.name.$params.maxLength.max + " " + $t('errors.error_letters')}}
        </span>
      </b-col>

      <b-col md="4">
        <b-input-group class="flex-column">
          <label class="d-block" :for="'member_limit'">{{ $t('form.member_limit') }}</label>
          <b-form-input
            min="0"
            class="mb-4 rounded"
            v-model="params.member_limit"
            name="member_limit"
            id="member_limit"
            type="number"
            @input="value => {createParamsObject('member_limit', value)}"
          />
        </b-input-group>
      </b-col>

      <b-col
        md="4"
        v-for="(input, index) in selects"
        :key="`${index}${input.name}`"
      >
        <label :for="input.name">{{ input.label }}</label>
        <multiselect
          class="mb-4"
          v-model="params[input.name]"
          :multiple="input.multiple"
          :id="input.name"
          label="name"
          track-by="name"
          :placeholder="input.placeholder"
          :options="input.options ||  allowed_email_regexp"
          :searchable="input.searchable"
          :allow-empty="true"
          :taggable="input.taggable"
          :close-on-select="!input.multiple"
          @tag="value => {addRegex('allowed_email_regexp', value)}"
          @remove="value => {createParamsObject(input.name, value)}"
          @input="value => {createParamsObject(input.name, value)}"
          select-label=""
          selected-label=""
          deselect-label="X "
          tag-placeholder="+">
          <template slot="noResult">
            {{$t('global.no_results')}}
          </template>
        </multiselect>
      </b-col>

      <b-col
        md="4"
        v-for="(input, index) in datepickers"
        :key="`${index}${input.name}`"
      >
        <label
          v-if="input.label"
        >{{ input.label }}</label>
        <DatePickerInput
            class="mb-4"
            v-model="params[input.name]"
            :mode="input.mode"
            @input="value => {createParamsObject(input.name, value)}"
            :is-range="input.isRange"
        />
      </b-col>

      <b-col
        md="4"
        v-for="(input, index) in groupSelects"
        :key="`${index}${input.name}`"
      >
        <group-select
          :input="input"
          :model="params[input.name]"
          @select="createParamsObject"
          @remove="createParamsObject"
        />
      </b-col>

      <b-col md="4">
        <label :for="'description'">{{ $t('form.description') }}</label>
        <b-form-textarea
          :rows="2"
          class="mb-4"
          v-model="description"
          name="description"
          id="description"
          @input="value => {createParamsObject('description', value)}"
        />
      </b-col>

    </b-row>

    <form-buttons @submit="debounceSubmit"></form-buttons>

  </b-col>
</template>

<script>
  import {required, maxLength} from "vuelidate/lib/validators";
  import i18n from "@/utils/i18n"
  import {datePickerMethods} from "../../mixins/date";
  import DatePickerInput from "../../components/forms/fields/datePickerInput";

  export default {
    name: 'GroupSubscriptionView',
    components: {DatePickerInput},
    props: {
      fields: {
        type: Array,
        require: true
      }
    },
    mixins: [datePickerMethods],
    data() {
      return {
        prefillParams: {},
        loading: false,
        name: '',
        description: '',
        params: {
          name: '',
          description: '',
          member_limit: '',
          allowed_email_regexp: [],
          active: {
            value: true,
            name: i18n.t('user_status.true')
          },
          type: '',
          subscription_id: null,
          subscription_end_date: null
        },
        paramsMutated: {},
        email_regex: [],
        selectsReady: false,
        groupMultiselects: {},
        debounceSubmit: () => {}
      }
    },
    validations: {
      name: {
        required,
        maxLength: maxLength(40)
      }
    },
    mounted() {
      if (this.$route.params.id) {
        this.getData(`teams/${this.$route.params.id}`, null, true)
          .then(({data}) => {
            this.prefillParams = data;
            this.setPrefillData(this.prefillParams)
          })
      }
      this.debounceSubmit = _.debounce(this.submit, 1000);
    },
    computed: {
      selects() {
        return _.filter(this.fields, input => input.type === 'select' && !input.group);
      },
      datepickers() {
        return _.filter(this.fields, input => input.type === 'date');
      },
      groupSelects() {
        return _.filter(this.fields, input => input.type === 'select' && input.group);
      },
    },
    methods: {
      addRegex(name, value) {
        const regex = {
          name: value,
          value: value,
          code: value
        };
        this.params[name].push(regex);
      },
      createParamsObject(name, value, remove = false) {
        if (_.isObject(name)) {
          value = name.value;
          remove = name.remove;
          name = name.field;
        }

        if (_.isObject(value)) {
          if (value instanceof Date) {
            value = this.formatDate(value, 'L');
            this.paramsMutated[name] = value;
          }
          if (value.hasOwnProperty('value')) {
            value = value.value;
            if (remove) {
              delete this.paramsMutated[name]
            } else {
              this.paramsMutated[name] = value;
            }
          } else {
            if (Array.isArray(value) && !value.length) {
              this.paramsMutated[name] = [];
            }
          }
        } else {
          this.paramsMutated[name] = value;
        }
      },
      setPrefillData(prefill) {
        this.name = prefill.name;
        this.description = prefill.description;
        this.params.name = prefill.name;
        this.params.description = prefill.description;
        this.params.member_limit = prefill.member_limit ? prefill.member_limit.toString() : null;
        if (prefill.allowed_email_regexp) {
          prefill.allowed_email_regexp.map(regexp => {
            if (regexp) {
              this.params.allowed_email_regexp.push({
                name: regexp,
                value: regexp
              })
            }
          })
        }
        if (prefill.type) {
          this.params.type = {
            name: i18n.t(`teams.${prefill.type}`),
            value: prefill.type
          }
        }
        if (prefill.active !== '') {
          this.params.active = {
            name: i18n.t(`user_status.${prefill.active}`),
            value: prefill.active
          }
        }
        this.params.subscription_id = prefill.subscription ? {label: prefill.subscription.title, value: prefill.subscription.id} : null;
        this.params.subscription_end_date = prefill.subscription_end_date ? new Date(prefill.subscription_end_date) : null;
        _.mapKeys(this.params, (value, key) => {
          this.createParamsObject(key, value);
        })
      },
      submit() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        if (!_.isEmpty(this.params.allowed_email_regexp)) {
          this.paramsMutated.allowed_email_regexp = this.params.allowed_email_regexp.map(param => {
            return param.value
          })
        }
        this.paramsMutated.member_limit = parseInt(this.params.member_limit);
        if (!_.isEmpty(this.prefillParams)) {
          this.loading = true;
          this.putData(`teams/${this.prefillParams.id}`, this.paramsMutated).then(() => {
            this.loading = false
          })
        } else {
          this.loading = true;
          this.postData('/teams', this.paramsMutated, '/groups').then(() => {
            this.loading = false
          })
        }
      }
    }
  }
</script>
